import './audioBars.style.css';

export const AudioBars = ({barColor}: {barColor: string}) => {
    return (
        <div
            className='boxContainer'
            style={{
                ['--barColor' as any]: barColor,
            }}
        >
            <div className='box box1'></div>
            <div className='box box2'></div>
            <div className='box box3'></div>
            <div className='box box4'></div>
            <div className='box box5'></div>
        </div>
    );
};
